import breakpoints from '../../styles/breakpoints.json'
import { Settings } from 'react-slick'

type ResponsiveSettings = {
  breakpoint: number
  settings: Settings
}

export const getResponsiveCarouselSettings = (
  slidesToShow: number,
  customSettings?: {
    lg?: Settings
    md?: Settings
    sm?: Settings
  }
): ResponsiveSettings[] => {
  const defaultSettings = [
    {
      breakpoint: Number(breakpoints['lg']),
      settings: {
        slidesToShow: Math.min(slidesToShow, 3),
        slidesToScroll: Math.min(slidesToShow, 3),
        ...customSettings?.lg
      }
    },
    {
      breakpoint: Number(breakpoints['md']),
      settings: {
        slidesToShow: slidesToShow >= 3 ? 2 : slidesToShow,
        slidesToScroll: slidesToShow >= 3 ? 2 : slidesToShow,
        ...customSettings?.md
      }
    },
    {
      breakpoint: Number(breakpoints['sm']) - 1,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        ...customSettings?.sm
      }
    }
  ]

  return defaultSettings
}
